<div class="relogin-wrapper fadein">
    <div class="login-bg-overlay"></div>

    <div class="login-card-inner">
        <header class="text-center mb-5">
            <img class="logo-main" 
                 *ngIf="!configService.appSettings?.frontend?.general?.showClientLogo" 
                 src="../../../assets/img/static/biworklims.svg" 
                 alt="Biwork LIMS">
            <img class="logo-main" 
                 *ngIf="configService.appSettings?.frontend?.general?.showClientLogo" 
                 id='client-logo' 
                 src="../../../assets/img/client/clientLogo.png" 
                 alt="Logo">
            
            <div class="greeting-area mt-4">
                <h1 class="text-600 font-light text-5xl m-0">Hola,</h1>
                <h2 class="text-primary font-bold text-3xl m-0 uppercase tracking-widest text-wrap">{{ data.user }}</h2>
            </div>
            <p class="text-500 mt-2 text-sm">Tu sesión ha expirado. Por favor reingresa tu contraseña.</p>
        </header>

        <form [formGroup]="form" (ngSubmit)="userLogin(form.value, data.client)" #documentEditForm="ngForm" class="flex flex-column gap-4">
            
            <div *ngIf="errorMessage" class="login-error-alert p-3 border-round flex align-items-center gap-2">
                <i class="pi pi-times-circle text-red-600 text-xl flex-shrink-0"></i>
                <span class="text-sm font-medium line-height-2">{{ errorMessage }}</span>
            </div>

            <div class="field mb-0">
                <p-floatLabel>
                    <input pInputText id="user" formControlName="user" autocomplete="off" class="w-full p-inputtext-lg" />
                    <label for="user">Usuario</label>
                </p-floatLabel>
            </div>
            
            <div class="field mb-0">
                <p-floatLabel>
                    <p-password 
                        id="password" 
                        formControlName="password" 
                        [toggleMask]="true" 
                        [feedback]="false" 
                        styleClass="w-full" 
                        inputStyleClass="w-full p-inputtext-lg" 
                        [disabled]="isLoading" 
                        autocomplete="current-password"
                        [autofocus]="true">
                    </p-password>
                    <label for="password">Contraseña</label>
                </p-floatLabel>
                <small class="p-error block mt-1" *ngIf="form.controls.password.invalid && form.controls.password.touched">
                    Contraseña requerida
                </small>
            </div>
            
            <div class="flex flex-column gap-3 mt-4 pt-4 border-top-1">
                <p-button 
                    label="Reingresar" 
                    type="submit" 
                    icon="pi pi-sign-in"
                    styleClass="w-full p-button-lg" 
                    [disabled]="form.invalid || isLoading" 
                    [loading]="isLoading">
                </p-button>
                
                <p-button 
                    label="Cerrar Sesión" 
                    (onClick)="cerrarSesion()" 
                    type="button" 
                    icon="pi pi-power-off"
                    [disabled]="isLoading"
                    styleClass="w-full p-button-secondary p-button-text">
                </p-button>
            </div>
        </form>
    </div>
</div>

